import React from "react";
import "./ExhibitorPowerForm.css";

const ExhibitorPowerForm = ({
  exhibitorPricePerKw,
  isViewOnly,
  isUnlocked, // ✅ NEW PROP
  powerFormStep,
  exhibitorPowerRequired,
  exhibitorPhase,
  exhibitorTotalAmount,
  onPowerChange,
  onPhaseChange,
  onNext,
  onPrevious,
  onAdd,
  onFinalSubmit,
  onUpdatePower, // ✅ NEW FUNCTION
  handlePowerUnlockRequest,
}) => {
  const steps = ["SETUP DAYS", "EXHIBITION DAYS"];

  const safeStep = powerFormStep ?? 0;
  const type = steps[safeStep];

  return (
    <form className="Exhibitor-power-requirement-stalls-form-wrapper">
      <h5>Additional Power Requirement</h5>

      <div className="Exhibitor-power-requirement-stalls-form-grid slide-active">
        {/* ROW 1 */}
        <div className="Exhibitor-power-requirement-stalls-form-row">
          <div className="Exhibitor-power-requirement-stalls-form-group">
            <label>TYPE:</label>
            <input type="text" value={type} readOnly />
          </div>

          <div className="Exhibitor-power-requirement-stalls-form-group">
            <label>PRICE PER KW:</label>
            <input type="text" value={exhibitorPricePerKw} readOnly />
          </div>
        </div>

        {/* ROW 2 */}
        <div className="Exhibitor-power-requirement-stalls-form-row-power">
          <div className="Exhibitor-power-requirement-stalls-form-group">
            <label>POWER REQUIRED:</label>
            <input
              type="number"
              value={exhibitorPowerRequired}
              onChange={onPowerChange}
              disabled={isViewOnly}
            />
          </div>

          <div className="Exhibitor-power-requirement-stalls-form-group">
            <label>PHASE:</label>

            <div className="Exhibitor-phase-options">
              <label>
                <input
                  type="radio"
                  name={`phase-${safeStep}`}
                  value="Single Phase"
                  checked={exhibitorPhase === "Single Phase"}
                  onChange={onPhaseChange}
                  disabled={isViewOnly}
                />
                Single
              </label>

              <label>
                <input
                  type="radio"
                  name={`phase-${safeStep}`}
                  value="Three Phase"
                  checked={exhibitorPhase === "Three Phase"}
                  onChange={onPhaseChange}
                  disabled={isViewOnly}
                />
                Three
              </label>
            </div>
          </div>
        </div>

        {/* ROW 3 */}
        <div className="Exhibitor-power-requirement-stalls-form-row-power">
          <div className="Exhibitor-power-requirement-stalls-form-group">
            <label>TOTAL AMOUNT:</label>
            <input type="text" value={exhibitorTotalAmount} readOnly />
          </div>

          <div className="Exhibitor-power-requirement-add-button-inline">
            {!isViewOnly ? (
              safeStep < 1 ? (
                <button type="button" onClick={onNext}>
                  Next
                </button>
              ) : isUnlocked ? (
                <button type="button" onClick={onUpdatePower}>
                  Update Power
                </button>
              ) : (
                <button type="button" onClick={onFinalSubmit}>
                  Submit
                </button>
              )
            ) : (
              <button
                type="button"
                className="unlock-request-btn"
                onClick={handlePowerUnlockRequest}
              >
                Request to Unlock
              </button>
            )}
          </div>
        </div>
      </div>
    </form>
  );
};

export default ExhibitorPowerForm;
